import { SourceMetadata } from 'generated/graphql';

export const getMetadataValues = (metadata: SourceMetadata) => {
  return (metadata.value.b ?? metadata.value.n ?? metadata.value.s ?? []).map(
    (value) => value.toString(),
  );
};
